import { render, staticRenderFns } from "./agreement1.vue?vue&type=template&id=53d88b13&scoped=true&"
import script from "./agreement1.vue?vue&type=script&lang=js&"
export * from "./agreement1.vue?vue&type=script&lang=js&"
import style0 from "./agreement1.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./agreement1.vue?vue&type=style&index=1&id=53d88b13&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d88b13",
  null
  
)

export default component.exports